module.exports = __webpack_public_path__ + "img/11th_military.081fffc6.webp";